const pendingForms = new Set();
const resetTimers = new WeakMap();

function updateLabel(label, text) {
  if (label.textContent === text) return;

  if (label.childNodes.length === 1 && label.firstChild?.nodeType === Node.TEXT_NODE) {
    label.firstChild.nodeValue = text;
  } else {
    label.textContent = text;
  }
}

function getSubmitButton(form) {
  return form.querySelector('[ref="addToCartButton"][type="submit"]');
}

function resetForm(form) {
  if (!pendingForms.has(form)) return;

  const button = getSubmitButton(form);
  const label = button?.querySelector('.add-to-cart-text__content > span > span');

  if (button) {
    button.removeAttribute('aria-busy');
    button.removeAttribute('data-cbn-adding');
    if (button.dataset.cbnWasDisabled !== 'true') button.disabled = false;
    delete button.dataset.cbnWasDisabled;
  }

  if (label?.dataset.cbnOriginalText) {
    updateLabel(label, label.dataset.cbnOriginalText);
    delete label.dataset.cbnOriginalText;
  }

  const timer = resetTimers.get(form);
  if (timer) window.clearTimeout(timer);
  resetTimers.delete(form);
  pendingForms.delete(form);
}

document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('main product-form-component')) return;

    if (pendingForms.has(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    const button = getSubmitButton(form);
    const label = button?.querySelector('.add-to-cart-text__content > span > span');
    if (!button || button.disabled || !label) return;

    pendingForms.add(form);
    label.dataset.cbnOriginalText = label.textContent.trim();
    updateLabel(label, button.dataset.addingText);
    button.dataset.cbnWasDisabled = String(button.disabled);
    button.dataset.cbnAdding = 'true';
    button.setAttribute('aria-busy', 'true');

    queueMicrotask(() => {
      if (pendingForms.has(form)) button.disabled = true;
    });

    resetTimers.set(form, window.setTimeout(() => resetForm(form), 15000));
  },
  true
);

function resetPendingForms() {
  pendingForms.forEach((form) => resetForm(form));
}

document.addEventListener('cart:update', resetPendingForms);
document.addEventListener('cart:error', resetPendingForms);
